<template>
  <div>
    <article class="media" v-for="product in getCart" :key="product.ean">
      <div class="media-left">
        <p class="image is-2by3">
          <img :src="product.image.medium">
        </p>
        <b-taglist attached>
          <b-tag type="is-warning">{{product.size}}</b-tag>
          <b-tag type="is-warning is-light">{{product.color}}</b-tag>
        </b-taglist>
      </div>
      <div class="media-content">
        <div class="content line-clamp">
          <strong>{{product.name}}</strong>
        </div>
        <div class="content">
          <b-numberinput type="is-dark" size="is-small" controls-position="compact" min="1" max="100" v-model="product.quantity" @input="updateCart(product)"></b-numberinput>
        </div>
      </div>
      <div class="media-right">
        <button class="delete" @click="removeCart(product)"></button>
      </div>
    </article>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import zipcelx from 'zipcelx'

export default {
  data () {
    return {
      cart: []
    }
  },
  computed: {
    ...mapGetters([
      'getCart'
    ])
  },
  methods: {
    ...mapActions([
      'setCart',
      'removeCart',
      'updateCart'
    ]),
    export () {
      console.log('export')
      var today = new Date();
      var date = today.getDate() + '-' + (today.getMonth()+1 < 10 ? '0' + (today.getMonth()+1) : today.getMonth()+1) + '-' + today.getFullYear()

      var data = []
      this.getCart.map(product => {
        data.push([
          {
            value: product.name,
            type: 'string'
          },
          {
            value: product.ean,
            type: 'string'
          },
          {
            value: product.reference,
            type: 'string'
          },
          {
            value: product.color,
            type: 'string'
          },
          {
            value: product.size,
            type: 'string'
          },
          {
            value: product.quantity,
            type: 'number'
          },
        ])
      })
      const config = {
        filename: 'leonisa ' + date,
        sheet: {
          data: data
        }
      }

      zipcelx(config)
    }
  }
}
</script>

<style scoped lang="scss">
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: .8rem;
  min-height: 103px;
  line-height: 1.1rem;
}
</style>
